// extracted by css-extract-rspack-plugin
export default {"headerIcon":"xwqMmyjIC4Yv133h","linkItem":"_oi9SpdLiPkWdsNf","linkText":"JwI_Q0KW0JctQ1D5","linkIconWrap":"Wj9NIGRYEjCkt8eK","linkUrl":"sUJEwoAtuicz9x9E"};